import { html, css } from 'lit-element';
import { connect } from '../core/connect';

import { withProduct } from '../core/resolveProperties';
import { TemplateElement } from '../core/base';
import { makeProductDefaultFrequencySelector, makeProductFrequencyOptedInSelector } from '../core/selectors';
import { safeProductId } from '../core/utils';

export class Price extends withProduct(TemplateElement) {
  static get properties() {
    return {
      ...super.properties,
      regular: { type: Boolean, reflect: true },
      subscription: { type: Boolean, reflect: true },
      discount: { type: Boolean, reflect: true },
      payAsYouGo: { type: Boolean, reflect: true, attribute: 'pay-as-you-go' },
      frequency: { type: Object },
      productPlans: { type: Object }
    };
  }

  static get styles() {
    return css`
      :host::before {
        clip-path: inset(100%);
        clip: rect(1px, 1px, 1px, 1px);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
      }

      :host([subscription])::before {
        content: 'Discounted subscription price';
      }

      :host([regular])::before {
        content: 'Regular price';
      }
    `;
  }

  get value() {
    const realProductId = safeProductId(this.product);
    const frequency = this.frequency || this.configDefaultFrequency || this.offer?.defaultFrequency;
    const plans = this.productPlans[realProductId] || [];

    if (this.payAsYouGo) {
      const payAsYouGoPlan = plans.find(plan => plan.prepaidShipments === null || plan.prepaidShipments === undefined);
      if (!payAsYouGoPlan) return '';
      return payAsYouGoPlan.subscriptionPrice;
    }

    const currentPlan = plans.find(plan => plan.frequency === frequency);
    if (!currentPlan) return '';
    const { regularPrice, discountRate, subscriptionPrice } = currentPlan;

    if (subscriptionPrice === regularPrice) return '';

    if (this.regular) {
      return regularPrice;
    }
    if (this.discount) return discountRate;
    return subscriptionPrice;
  }

  render() {
    const value = this.value;
    if (value)
      return html`
        <slot name="prepend"></slot>
        ${value}
        <slot name="append"></slot>
      `;

    return html`
      <slot name="fallback"></slot>
    `;
  }
}
const mapStateToProps = (state, ownProps) => ({
  productPlans: state.productPlans,
  configDefaultFrequency: makeProductDefaultFrequencySelector(ownProps.product?.id)(state),
  frequency: makeProductFrequencyOptedInSelector(ownProps.product)(state)
});

export default connect(mapStateToProps)(Price);
